<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <img
        v-if="data.currency == 'gbp'"
        class="currency-flag"
        src="@/assets/flags/GB.png"
      />
      <img
        v-if="data.currency == 'usd'"
        class="currency-flag"
        src="@/assets/flags/US.png"
      />
      <img
        v-if="data.currency == 'eur'"
        class="currency-flag"
        src="@/assets/flags/EU.png"
      />
      {{ data.currency.toUpperCase() }}
      <ul class="summary-data">
        <li>Value : {{ data.value.toFixed(2) }}</li>
        <li>Bookings : {{ data.bookings }}</li>
        <li>Travellers : {{ data.travellers }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    data: Array
  }
};
</script>
<style lang="scss" scoped>
.currency-flag {
  width: auto;
  vertical-align: text-bottom;
  margin-right: 10px;
}

.summary-data {
  list-style-type: none;
  margin: 0;
  padding: 10px;
}
</style>
